import { render } from "./DevicesMain.vue?vue&type=template&id=960b3fae&scoped=true"
import script from "./DevicesMain.vue?vue&type=script&lang=js"
export * from "./DevicesMain.vue?vue&type=script&lang=js"

import "./DevicesMain.vue?vue&type=style&index=0&id=960b3fae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-960b3fae"]])

export default __exports__